export default __webpack_public_path__ + "static/media/MdroContact.2878f019.svg";